// https://www.edgestudio.com/talent-library/search - Solomon A
const live = require("../assets/audios/audio-74658.mp3");

export default {
  live,
};
